/**
 * Atributos del tema que NO cambian entre temas (comunes a todos).
 * Usar con createTheme(themeBase, { palette: {...}, components: {...} }) en cada CustomTheme*.
 */
import { createTheme, Theme, ThemeOptions } from "@mui/material";

export const themeBase: ThemeOptions = createTheme({
  palette: {
    fontWeights: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
  typography: {
    fontFamily: ["Outfit"].join(","),
    h1: {
      fontSize: 39,
      fontWeight: 300,
    },
    h2: {
      fontSize: 31,
      fontWeight: 300,
    },
    h3: {
      fontSize: 25,
      fontWeight: 300,
    },
    h4: {
      fontSize: 20,
      fontWeight: 300,
    },
    h5: {
      fontSize: 16,
      fontWeight: 300,
    },
    body1: {
      fontSize: 16,
      fontWeight: 300,
    },
    body2: {
      fontSize: 13,
      fontWeight: 300,
    },
    body3: {
      fontSize: 11,
      fontWeight: 300,
      fontFamily: "Outfit",
    },
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: ({ theme }: { theme: Theme }) => ({
          color: theme.palette.primary.light,
        }),
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: ({ theme }: { theme: Theme }) => ({
          color: theme.palette.primary.light,
        }),
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "#FF6060",
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        determinate: ({ theme }: { theme: Theme }) => ({
          color: theme.palette.primary.light,
        }),
        indeterminate: ({ theme }: { theme: Theme }) => ({
          color: theme.palette.primary.main,
        }),
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: "14px",
          boxShadow: "8px 4px 20px 0px rgba(82, 140, 214, 0.25)",
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          // backgroundColor: "rgba(0, 0, 0, 0.5)",
          // border: "2px red solid"
          // ".aria-labelledby": {
          //   border: "2px blue solid"
          // }
        },
      },
    },
    // MuiTextField: {
    //   styleOverrides: {
    //     root: ({ theme }: { theme: Theme }) => ({
    //       "& .MuiOutlinedInput-root": {
    //         borderRadius: "10px",
    //       },
    //       "& .MuiFilledInput-root": {
    //         borderRadius: "10px",
    //       },
    //       "& .MuiInputBase-root": {
    //         borderRadius: "10px",
    //       },
    //       "& .MuiOutlinedInput-notchedOutline": {
    //         borderColor: theme.palette.primary.light,
    //       },
    //       "& .MuiInput-underline::before": {
    //         borderColor: theme.palette.primary.light,
    //       },
    //       "& .MuiFilledInput-underline::before": {
    //         borderColor: theme.palette.primary.light,
    //       },
    //       "& .MuiInputLabel-asterisk": {
    //         color: "#CD0202",
    //       },
    //     }),
    //   },
    // },
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       borderRadius: 6,
    //       padding: "10px 25px",
    //       textTransform: "none",
    //       fontSize: 16,
    //       fontWeight: 700,
    //     },
    //   },
    //   variants: [
    //     {
    //       props: {
    //         variant: "default",
    //       },
    //       style: ({ theme }: { theme: Theme }) => ({
    //         backgroundColor: theme.palette.primary.main,
    //         color: "#FFF",
    //         "&.Mui-disabled": {
    //           backgroundColor: theme.palette.primary.main,
    //           opacity: 0.4,
    //           color: "#FFF",
    //         },
    //         "&:hover": {
    //           backgroundColor: theme.palette.primary.dark,
    //           color: theme.palette.primary.light,
    //         },
    //         "&.MuiButton-defaultSizeSmall": {
    //           fontSize: 11,
    //           fontWeight: 600,
    //           padding: "2px 8px",
    //         },
    //       }),
    //     },
    //     {
    //       props: {
    //         variant: "default_disabled",
    //       },
    //       style: {
    //         backgroundColor: "#D45D00",
    //         opacity: 0.4,
    //         color: "#FFF",
    //         // "&.Mui-disabled": {
    //         //   backgroundColor: "#528CD6",
    //         //   opacity: 0.4,
    //         //   color: "#FFF",
    //         // },
    //         "&:hover": {
    //           backgroundColor: "#D45D00",
    //           color: "#FFF",
    //         },
    //         "&.MuiButton-defaultSizeSmall": {
    //           fontSize: 11,
    //           fontWeight: 600,
    //           padding: "2px 8px",
    //         },
    //       },
    //     },
    //     {
    //       props: {
    //         variant: "contained",
    //       },
    //       style: {
    //         "&.Mui-disabled": {
    //           backgroundColor: "#D45D00",
    //           opacity: 0.4,
    //           color: "#FFF",
    //         },
    //       },
    //     },
    //     {
    //       props: {
    //         variant: "orange",
    //       },
    //       style: {
    //         backgroundColor: "#F2704F",
    //         color: "#FFF",
    //         "&.Mui-disabled": {
    //           backgroundColor: "#F2704F",
    //           opacity: 0.4,
    //         },
    //         "&:hover": {
    //           backgroundColor: "#F2704F",
    //         },
    //       },
    //     },
    //     {
    //       props: {
    //         variant: "black",
    //       },
    //       style: {
    //         backgroundColor: "#2C2C2C",
    //         color: "#FFF",
    //         "&.Mui-disabled": {
    //           backgroundColor: "#2C2C2C",
    //           opacity: 0.4,
    //         },
    //         "&:hover": {
    //           backgroundColor: "#2C2C2C",
    //         },
    //       },
    //     },
    //     {
    //       props: {
    //         variant: "blue_outlined",
    //       },
    //       style: {
    //         color: "#333F48",
    //         backgroundColor: "#FFF",
    //         border: "2px solid #333F48",
    //         lineHeight: "22px",
    //         "&.Mui-disabled": {
    //           color: "#bdbdbd",
    //           border: "2px solid #bdbdbd",
    //           backgroundColor: "transparent",
    //         },
    //         "&.MuiButton-blue_outlinedSizeSmall": {
    //           fontSize: 11,
    //           fontWeight: 600,
    //           padding: "2px 8px",
    //         },
    //       },
    //     },
    //     {
    //       props: {
    //         variant: "blue_demon",
    //       },
    //       style: {
    //         // color: "#FFC72C",
    //         color: "#FFFFFF",
    //         backgroundColor: "#333F48",
    //         "&.Mui-disabled": {
    //           color: "#FFFFFF",
    //           backgroundColor: "#333F48",
    //           opacity: 0.4,
    //         },
    //         "&:hover": {
    //           backgroundColor: "#333F48",
    //         },
    //       },
    //     },
    //     {
    //       props: {
    //         variant: "green",
    //       },
    //       style: {
    //         color: "#FFFFFF",
    //         backgroundColor: "#00BB2D",
    //         "&.Mui-disabled": {
    //           backgroundColor: "#009A24",
    //           opacity: 0.4,
    //         },
    //         "&:hover": {
    //           backgroundColor: "#009A24",
    //         },
    //       },
    //     },
    //     {
    //       props: {
    //         variant: "expediente_validado",
    //       },
    //       style: ({ theme }: { theme: Theme }) => ({
    //         width: "150px",
    //         height: "30px",
    //         fontSize: 15,
    //         color: theme.palette.primary.main,
    //         backgroundColor: theme.palette.primary.light,
    //         "&.Mui-disabled": {
    //           backgroundColor: theme.palette.primary.light,
    //           opacity: 0.4,
    //         },
    //         "&:hover": {
    //           backgroundColor: theme.palette.primary.light,
    //         },
    //       }),
    //     },
    //     {
    //       props: {
    //         variant: "expediente_validado",
    //         size: "small",
    //       },
    //       style: {
    //         width: "90px",
    //         height: "23px",
    //         fontSize: 13,
    //       },
    //     },
    //     {
    //       props: {
    //         variant: "expediente",
    //       },
    //       style: ({ theme }: { theme: Theme }) => ({
    //         paddingLeft: "10px",
    //         paddingRight: "10px",
    //         width: "150px",
    //         height: "30px",
    //         fontSize: 15,
    //         backgroundColor: theme.palette.primary.main,
    //         color: "#FFF",
    //         "&.Mui-disabled": {
    //           backgroundColor: theme.palette.primary.main,
    //           opacity: 0.4,
    //           color: "#FFF",
    //         },
    //         "&:hover": {
    //           backgroundColor: theme.palette.primary.dark,
    //           color: theme.palette.primary.light,
    //         },
    //       }),
    //     },
    //     {
    //       props: {
    //         variant: "expediente",
    //         size: "small",
    //       },
    //       style: {
    //         width: "90px",
    //         height: "23px",
    //         fontSize: 13,
    //       },
    //     },
    //     {
    //       props: {
    //         variant: "yellow",
    //       },
    //       style: {
    //         backgroundColor: "#FF9D14",
    //         color: "#FFF",
    //         "&.Mui-disabled": {
    //           backgroundColor: "#FF9D14",
    //           opacity: 0.4,
    //           color: "#FFF",
    //         },
    //         "&:hover": {
    //           backgroundColor: "#FF9D14",
    //           color: "#FFF",
    //         },
    //         "&.MuiButton-defaultSizeSmall": {
    //           fontSize: 11,
    //           fontWeight: 600,
    //           padding: "2px 8px",
    //         },
    //       },
    //     },
    //   ],
    // },
    // MuiFormControl: {
    //   styleOverrides: {
    //     root: ({ theme }: { theme: Theme }) => ({
    //       "& .MuiInputLabel-asterisk": {
    //         color: "#CD0202",
    //       },
    //       "& .MuiOutlinedInput-root": {
    //         "& fieldset": {
    //           borderColor: theme.palette.primary.light,
    //           borderRadius: "5px",
    //         },
    //         "&:hover fieldset": {
    //           borderColor: theme.palette.primary.light,
    //         },
    //         "&.Mui-focused fieldset": {
    //           borderColor: theme.palette.primary.light,
    //         },
    //       },
    //       "& .MuiSelect-icon": {
    //         color: theme.palette.primary.light,
    //       },
    //     }),
    //   },
    // },
    // MuiSelect: {
    //   styleOverrides: {
    //     root: ({ theme }: { theme: Theme }) => ({
    //       "& .MuiOutlinedInput-notchedOutline": {
    //         borderColor: theme.palette.primary.light,
    //       },
    //     }),
    //   },
    // },
    // MuiMenu: {
    //   styleOverrides: {
    //     paper: {
    //       borderRadius: "14px",
    //       boxShadow: "8px 4px 20px 0px rgba(82, 140, 214, 0.25)",
    //     },
    //   },
    // },
    // MuiModal: {
    //   styleOverrides: {
    //     root: {
    //       // backgroundColor: "rgba(0, 0, 0, 0.5)",
    //       // border: "2px red solid"
    //       // ".aria-labelledby": {
    //       //   border: "2px blue solid"
    //       // }
    //     },
    //   },
    // },
    // MuiFormControlLabel: {
    //   styleOverrides: {
    //     root: ({ theme }: { theme: Theme }) => ({
    //       color: theme.palette.primary.dark,
    //     }),
    //   },
    // },
  },
});
